import React, { useEffect, useState, useContext } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Switch,
  TextField,
  IconButton,
  Button,
  makeStyles,
  Typography,
  CircularProgress,
  Grid,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import StyledButton from "../../../common/models/Button";
import { appUrl } from "../../../../utils/config";
import axios from "axios";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import { he } from "date-fns/locale";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: theme.spacing(2),
  },
  table: {
    backgroundColor: "#fff",
    border: "1px solid #ddd",
    width: "650px",
  },
  headerCell: {
    fontWeight: 600,
    backgroundColor: "#f0f0f0",
    padding: "10px 16px",
    textAlign: "left",
  },
  bodyCell: {
    padding: "10px 16px",
    textAlign: "left",
    verticalAlign: "middle",
  },
  textField: {
    "& input": {
      padding: "6px 8px",
      height: "30px",
    },
  },
  inlineActions: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "8px",
    gap: "4px",
  },
  iconBtn: {
    padding: "0.5px",
  },
  addButton: {
    marginTop: theme.spacing(2),
    backgroundColor: "#fff",
    color: "#000",
    borderRadius: "20px",
    padding: "6px 16px",
    textTransform: "none",
    fontWeight: 600,
    border: "1px solid #000",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  addIconCircle: {
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    border: "2px solid #000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: theme.spacing(1),
    fontSize: "16px",
    fontWeight: 600,
  },
  deleteIcon: {
    color: theme.palette.error.main,
  },
  switchBase: {
    "&.Mui-checked": {
      color: "#007bff",
    },
    "&.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#007bff",
    },
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    marginTop: theme.spacing(4),
  },
  inlineActions: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "8px",
    gap: "4px",
  },
  iconBtn: {
    padding: "1px",
  },
  saveButton: {
    backgroundColor: "#EC6535",
    color: "#fff",
    borderRadius: "20px",
    // padding: "8px 24px",
    textTransform: "none",
    width: "12rem",
    fontSize: "1rem",
    fontWeight: 550,
    cursor: "pointer",
    // paddingLeft:"3rem",
    // paddingRight:"3rem",
    paddingTop: "0.35rem",
    paddingBottom: "0.35rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "5rem",
    "&:hover": {
      backgroundColor: "#993d13",
    },
  },
  backButton: {
    backgroundColor: "#707070",
    color: "#fff",
    borderRadius: "20px",
    // padding: "8px 24px",
    textTransform: "none",
    width: "12rem",
    fontSize: "1rem",
    fontWeight: 550,
    cursor: "pointer",
    // paddingLeft:"3rem",
    // paddingRight:"3rem",
    paddingTop: "0.35rem",
    paddingBottom: "0.35rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "5rem",
    "&:hover": {
      backgroundColor: "#4d4d4d",
    },
  },
}));

const FormatTypeTab = (props) => {
  const { addSponsorList, rowData,rowNetwork,updateNetworkData } = props;
  const classes = useStyles();

  const [formatTypes, setFormatTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isUpdated, setIsUpdated] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [savingStates, setSavingStates] = useState({});
  const [isSaving, setIsSaving] = useState(false); // Track save & next button loading

  const dispatch = (action) => {
    if (action.type === "OPEN_BACKDROP") {
    } else if (action.type === "DESTROY_BACKDROP") {
    }
  };

     const network=addSponsorList?.data?.network || rowNetwork;
   const networkUrl=updateNetworkData?.ecosystemUrl || rowData?.networkURL;

  const fetchFormatTypes = async () => {
    setError(null);
    setLoading(true);
    dispatch({ type: "OPEN_BACKDROP" });

    try {
      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/fetchFileFormatTypes/false`;
      const response = await axios.get(url);
      const data = response?.data?.data;


      if (data?.status === true || data?.status === "true") {
        const list = data.fileFormatTypesList || [];

        const formatted = list.map((item, index) => ({
          id: item.fileFormatTypeID || `ID-${index + 1}`,
          name: item.fileFormatTypeName || "",
          selected: !!item.activated,
          isNew: false,
          type: item.fileFormatType,
        }));

        setFormatTypes(formatted);
      } else {
        setError("Something went wrong. Please try again.");
      }
    } catch (err) {
      console.error("API Error:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
      dispatch({ type: "DESTROY_BACKDROP" });
    }
  };

  useEffect(() => {
    fetchFormatTypes();
  }, []);

  const saveFormatType = async (index) => {
    if (savingStates[index]) return;
    setSavingStates((prev) => ({ ...prev, [index]: true }));
    try {
      const formatToSave = formatTypes[index]; // Get the format type to save
      if (!formatToSave.name.trim()) {
        setError("Please provide a name for the format type.");
        setSavingStates((prev) => ({ ...prev, [index]: false }));
        return;
      }

      // Prepare the payload for the API
      const payload = {
        ecosystemId:addSponsorList?.data?.ecosystemId || rowData?.ecosystemId,
      sponsorId: addSponsorList?.data?.organizationId || rowData?.organizationId,
        fileFormatTypesList: [
          {
            fileFormatType: "New", // Type of the format
            fileFormatTypeName: formatToSave.name, // Name of the format type
            activated: formatToSave.selected, // Default to true if not set
          },
        ],
      };


      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/addFileFormatTypes`; // API endpoint
      const response = await axios.post(url, payload);
      
      if (response.data?.status === true || response.data?.status === "true") {
        fetchFormatTypes();
        props.setFormatType((prev) => !prev);

        // Update the state to mark the format type as saved
        setFormatTypes((prev) =>
          prev.map((format, i) =>
            i === index
              ? { ...format, id: response.data?.data?.id, isNew: false }
              : format
          )
        );
      } else {
        console.error("Failed to save format type:", response.data?.message);
        setError(response.data?.message || "Failed to save format type.");
      }
    } catch (error) {
      console.error("Error saving format type:", error);
      setError("An error occurred while saving the format type.");
    }
    setSavingStates((prev) => ({ ...prev, [index]: false }));
  };
  const handleDelete = async (index) => {
    try {
      const formatToDelete = formatTypes[index]; // Get the format type to delete
      if (formatToDelete.isNew) {
        setFormatTypes((prev) => prev.filter((_, i) => i !== index));
        return;
      }

      // Prepare the payload for the API
      const payload = {
        ecosystemId:addSponsorList?.data?.ecosystemId || rowData?.ecosystemId,
      sponsorId: addSponsorList?.data?.organizationId || rowData?.organizationId,
        fileFormatTypesList: [
          {
            fileFormatTypeID: formatToDelete.id, // ID of the format type
            fileFormatType: formatToDelete.type, // Type of the format
            fileFormatTypeName: formatToDelete.name, // Name of the format type
            activated: formatToDelete.selected, // Current activation state
            markForDelete: true, // Mark the format type for deletion
          },
        ],
      };


      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/updateFileFormatTypes`; // API endpoint
      const response = await axios.post(url, payload);
      fetchFormatTypes();

      if (response.data?.status === true || response.data?.status === "true") {
        props.setFormatType((prev) => !prev);
        // Update the state to remove the deleted format type
        setFormatTypes((prev) => prev.filter((_, i) => i !== index));
      } else {
        console.error("Failed to delete format type:", response.data?.message);
        setError(response.data?.message || "Failed to delete format type.");
      }
    } catch (error) {
      console.error("Error deleting format type:", error);
      setError("An error occurred while deleting the format type.");
    }
  };

  const handleNextClick = async () => {
    try {
      // Validate that at least one file format type is selected
      const isAnyFormatSelected = formatTypes.filter(
        (format) => format.isUpdated
      );

      if (!isAnyFormatSelected.length) {
        // props.handleNext(); // Directly move to the next tab
      props.handleNext(); // Directly move to the next tab();
        return;
      }

      // if (!isAnyFormatSelected.length) {
      //   setErrorMessage("Please activate at least one file format type.");
      //   return;
      // }
      if (formatTypes.every((format) => !format.selected)) {
        setErrorMessage("Please enable at least one in toggle mode.");
        return;
      }

      setIsSaving(true); // Start loading

      // Prepare the payload for the API
      const payload = {
         ecosystemId:addSponsorList?.data?.ecosystemId || rowData?.ecosystemId,
      sponsorId: addSponsorList?.data?.organizationId || rowData?.organizationId,
        fileFormatTypesList: isAnyFormatSelected.map((format) => ({
          fileFormatTypeID: format.id, // ID of the format type
          fileFormatType: format.type, // Type of the format
          fileFormatTypeName: format.name, // Name of the format type
          activated: format.selected, // Activation state
        })),
      };


      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/updateFileFormatTypes`; // API endpoint
      const response = await axios.post(url, payload);
      fetchFormatTypes();

      if (response.data?.status === true || response.data?.status === "true") {

        // Move to the next tab
        if (props.handleNext) {
          props.handleNext();
        }
      } else {
        console.error(
          "Failed to update file format types:",
          response.data?.message
        );
        setError(
          response.data?.message || "Failed to update file format types."
        );
      }
    } catch (error) {
      console.error("Error updating file format types:", error);
      setError("An error occurred while updating file format types.");
    } finally {
      setIsSaving(false); // Stop loading
    }
  };
  const handleToggle = (index) => {
    const updated = [...formatTypes];
    updated[index].selected = !updated[index].selected;
    updated[index].isUpdated = true;
    setFormatTypes(updated);
    setIsUpdated(true);
  };

  const handleNameChange = (index, value) => {
    const updated = [...formatTypes];
    updated[index].name = value;
    setFormatTypes(updated);
    setIsUpdated(true);
  };

  // const handleDelete = (index) => {
  //   const updated = formatTypes.filter((_, i) => i !== index);
  //   setFormatTypes(updated);
  // };

  const handleAddFormat = () => {
    //const nextId = (formatTypes.length + 1).toString().padStart(2, "0");
    setFormatTypes([
      ...formatTypes,
      {
        //  id: nextId,
        name: "",
        selected: false,
        isNew: true,
      },
    ]);
  };

  const handleCancel = (index) => {
    const formatType = formatTypes[index]; // Get the formatType by index

    // Remove the formatType from the list
    const updated = formatTypes.filter((_, i) => i !== index);
    setFormatTypes(updated); // Update the state
  };

  return (
    <div className={classes.container}>
      <div>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell className={classes.headerCell}>Selection</TableCell>
              <TableCell className={classes.headerCell}>Format Type</TableCell>
              <TableCell className={classes.headerCell}>
                Format Type ID
              </TableCell>
              <TableCell className={classes.headerCell}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={4}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100px",
                    }}
                  >
                    <CircularProgress />
                  </div>
                </TableCell>
              </TableRow>
            ) : error ? (
              <TableRow>
                <TableCell colSpan={4}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "60px",
                      backgroundColor: "#ffecec",
                      color: "#b00020",
                      border: "1px solid #ff9999",
                    }}
                  >
                    <Typography>{error}</Typography>
                  </div>
                </TableCell>
              </TableRow>
            ) : (
              formatTypes.map((item, index) => (
                <TableRow key={item.id}>
                  <TableCell className={classes.bodyCell}>
                    <Switch
                      checked={item.selected}
                      onChange={() => handleToggle(index)}
                      classes={{ switchBase: classes.switchBase }}
                    />
                  </TableCell>
                  <TableCell className={classes.bodyCell}>
                    {item.isNew ? (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <TextField
                          placeholder="Type Text Here"
                          value={item.name}
                          onChange={(e) =>
                            handleNameChange(index, e.target.value)
                          }
                          className={classes.textField}
                          variant="outlined"
                          inputProps={{
                            onBeforeInput: (e) => {
                              const allowedChars = /^[a-zA-Z.]+$/;
                              if (!allowedChars.test(e.data)) {
                                e.preventDefault();
                              }
                            }
                          }}
                        />
                        <div className={classes.inlineActions}>
                          <IconButton
                            onClick={() => handleCancel(index)}
                            className={classes.iconBtn}
                          >
                            <CancelIcon fontSize="small" />
                          </IconButton>
                          <IconButton
                            onClick={() => saveFormatType(index)}
                            className={classes.iconBtn}
                            disabled={
                              !formatTypes[index].name?.trim() ||
                              formatTypes.some(
                                (f, i) =>
                                  i !== index &&
                                  f.name?.trim().toLowerCase() === formatTypes[index].name?.trim().toLowerCase()
                              ) || savingStates[index]
                            }
                          >
                            <SaveIcon fontSize="small" />
                          </IconButton>
                        </div>
                      </div>
                    ) : (
                      item.name
                    )}
                  </TableCell>
                  <TableCell className={classes.bodyCell}>{item.id}</TableCell>
                  <TableCell className={classes.bodyCell}>
                    {/* {item.isNew && ( */}
                    {(item.isNew == true || item.type === "New") && (
                      <IconButton
                        aria-label="delete"
                        onClick={() => handleDelete(index)}
                      >
                        <DeleteIcon className={classes.deleteIcon} />
                      </IconButton>
                    )}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
        {errorMessage && (
          <div
            style={{ color: "red", marginTop: 10 }}
            className="error-message"
          >
            {errorMessage}
          </div>
        )}

        <Button
          variant="outlined"
          onClick={handleAddFormat}
          className={classes.addButton}
        >
          <span className={classes.addIconCircle}>+</span>
          Add New Format Type
        </Button>

        <div className={classes.footer}>
         <Grid
          className={classes.backButton}
          onClick={() => {
            props.handleBack();
          }}
        >
          <ChevronLeftIcon />
          Back
        </Grid>
        <Grid
          className={classes.saveButton}
            onClick={() => isUpdated ?handleNextClick()
              : props.handleNext()} // Check if updates are made
          style={{ 
            opacity: isSaving ? 0.7 : 1, 
            pointerEvents: isSaving ? 'none' : 'auto' 
          }}
          >
          {isSaving ? (
            <>
              <CircularProgress size={16} color="inherit" style={{ marginRight: '8px' }} />
              Saving...
            </>
          ) : (
            <>
              Save & Next
              <ChevronRightIcon />
            </>
          )}
        </Grid>
        </div>
      </div>
    </div>
  );
};

export default FormatTypeTab;
